require('../../modules/es6.object.keys');
module.exports = require('../../modules/_core').Object.keys;



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.10@core-js/library/fn/object/keys.js
// module id = 9
// module chunks = 0